import React from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import { useState } from "react";
import { triggerNotification } from "../../component/message/Msg";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../config";
import { useEffect } from "react";
import Spinner from "../../component/loadingbar/Spinner";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import MediaPopup from "../../component/mediapopup/MediaPopup";

const AddAssignmentQue = () => {
  const { id, ctype, cid } = useParams();
  const token = config.token;
  const navigate = useNavigate();

  const [assignmentFor, setAssignmentFor] = useState("course");
  const [loading, setLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [chapters, setChapters] = useState([]);

  //----------------------------------- state management -----------------------------
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [selectedChapterId, setSelectedChapterId] = useState("");
  const [assgTitle, setAssgTitle] = useState("");
  const [assgTimeLimit, setAssgTimeLimit] = useState("");
  const [assgTimeUnit, setAssgTimeUnit] = useState("hours");
  const [assgPoints, setAssgPoints] = useState("");
  const [assgPassingPoints, setAssgPassingPoints] = useState("");
  const [assgNoFileAllw, setAssgNoFileAllw] = useState("");
  const [assgMaxFileSize, setAssgMaxFileSize] = useState("");
  const [assgLinkValue, setAssgLinkValue] = useState([]);
  const [assgSummary, setAssgSummary] = useState("");
  const [isCourseDropdownOpen, setIsCourseDropdownOpen] = useState(false);
  const [isChapterDropdownOpen, setIsChapterDropdownOpen] = useState(false);
  const [courseSearchTerm, setCourseSearchTerm] = useState('');
  const [chapterSearchTerm, setChapterSearchTerm] = useState('');

  const handleSelectedCourseIdChange = (courseId) => {
    setSelectedCourseId(courseId);
    setCourseSearchTerm("");

    if (assignmentFor === "chapter") {
      // Fetch chapter list
      fetch(`${config.host_url}pages/chaptersbycourse/${courseId}`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            setChapters(data.data);
          } else if (data.status === 401) {
            // Invalid token
            console.error("Invalid token");
          } else {
            // Handle other errors
            console.error("Internal server error");
          }
        })
        .catch((error) => {
          console.error("Error fetching chapter:", error);
        });
    }
  };

  const handleAssignmentForRadioChange = (e) => {
    setAssignmentFor(e.target.value);
    setChapters([]); // Clear chapters on changing assignment
    setSelectedChapterId('');
    setSelectedCourseId('');
  };

  const filteredCourses = courses.filter((course) =>
    course.course_name.toLowerCase().includes(courseSearchTerm.toLowerCase())
  );

  const filteredChapters = chapters.filter((chapter) =>
    chapter.name.toLowerCase().includes(chapterSearchTerm.toLowerCase())
  );

  const handleSelectedChapterIdChange = (e) => {
    setSelectedChapterId(e.target.value);
  };
  const handleAssgTitleChange = (e) => {
    setAssgTitle(e.target.value);
  };
  const handleAssgPointsChange = (e) => {
    setAssgPoints(e.target.value);
  };
  const handleAssgTimeLimitChange = (e) => {
    setAssgTimeLimit(e.target.value);
  };
  const handleAssgPassingPointsChange = (e) => {
    setAssgPassingPoints(e.target.value);
  };
  const handleAssgNoFileAllwChange = (e) => {
    setAssgNoFileAllw(e.target.value);
  };
  const handleAssgMaxFileSizeChange = (e) => {
    setAssgMaxFileSize(e.target.value);
  };
  const handleAssgTimeUnitChange = (e) => {
    setAssgTimeUnit(e.target.value);
  };
  const handleAssgSummaryChange = (data) => {
    setAssgSummary(data);
  };
  const assignmentForRadioChange = (event) => {
    setChapters([]);
    setSelectedChapterId("");
    setSelectedCourseId("");
    setAssignmentFor(event.target.id);
  };

  //-------------------------------------- clear form data --------------------------------------r
  const clearForm = () => {
    setSelectedCourseId("");
    setAssgTitle("");
    setAssgTimeLimit("");
    setAssgTimeUnit("hours");
    setAssgPoints("");
    setAssgPassingPoints("");
    setAssgNoFileAllw("");
    setAssgMaxFileSize("");
    setAssgLinkValue([]);
    setAssgSummary("");
  };

  // ---------------------------------- fetch assignment for edit ------------------------------------
  const updateFieldValueSet = async () => {
    setLoading(true);
    try {
      await fetch(
        `${config.host_url}assignments/${decodeURIComponent(atob(id))}`,
        {
          method: "GET",
          headers: {
            token: token,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            console.log(data.data);
            const responseData = data.data;
            responseData.courseid && setSelectedCourseId(responseData.courseid);
            responseData.title && setAssgTitle(responseData.title);
            responseData.summary && setAssgSummary(responseData.summary);
            responseData.points && setAssgPoints(responseData.points);
            responseData.passing_points &&
              setAssgPassingPoints(responseData.passing_points);
            responseData.time_limit &&
              setAssgTimeLimit(responseData.time_limit);
            responseData.no_of_file_allowed &&
              setAssgNoFileAllw(responseData.no_of_file_allowed);
            responseData.time_limit_unit &&
              setAssgTimeUnit(responseData.time_limit_unit);
            responseData.max_file_size &&
              setAssgMaxFileSize(responseData.max_file_size);
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching courses.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id !== undefined) {
      updateFieldValueSet();
    }
  }, [id]);
  // ---------------------------------- fetch course ------------------------------------
  //fetch data
  useEffect(() => {
    // Fetch course list
    fetch(`${config.host_url}course`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setCourses(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching courses:", error);
      });
  }, [token]);

  // ---------------------------------------------- create / add Assignment  ----------------------------------------------------c
  // Function to create a assignment
  const addAssignment = async () => {
    try {
      if (
        (!id && assgLinkValue.length <= 0) ||
        (!id && !selectedCourseId) ||
        !assgTitle.trim() ||
        !assgSummary.trim() ||
        assgPoints <= 0 ||
        assgPassingPoints <= 0 ||
        assgTimeLimit <= 0 ||
        assgNoFileAllw < 0 ||
        assgMaxFileSize <= 0
      ) {
        triggerNotification("error", "Input fields cannot be empty!!");
        return;
      }

      fetch(
        `${config.host_url}assignments/${id ? decodeURIComponent(atob(id)) : ""
        }`,
        {
          method: `${id ? "PUT" : "POST"}`,
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
          body: JSON.stringify({
            assignments: assgLinkValue,
            ...(!id && {
              [assignmentFor === "chapter" ? "chapterid" : "courseid"]:
                assignmentFor === "chapter"
                  ? selectedChapterId
                  : selectedCourseId,
            }),
            title: assgTitle,
            summary: assgSummary,
            time_limit: assgTimeLimit,
            time_limit_unit: assgTimeUnit,
            points: assgPoints,
            passing_points: assgPassingPoints,
            no_of_file_allowed: assgNoFileAllw,
            max_file_size: assgMaxFileSize,
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // assignment created successfully
            triggerNotification(
              "success",
              `${id
                ? "Assignment updated successfully."
                : "Assignment created successfully."
              }`
            );
            setAssgLinkValue([]);
            setSelectedCourseId("");
            setAssgTitle("");
            setAssgSummary("");
            setAssgPoints("");
            setAssgPassingPoints("");
            setAssgTimeLimit("");
            setAssgNoFileAllw("");
            setAssgMaxFileSize("");

            cid
              ? ctype === "course"
                ? navigate(`/viewcourse/${cid}`)
                : navigate(`/viewchapter/${cid}`)
              : assignmentFor === "course"
                ? navigate(
                  `/viewcourse/${btoa(encodeURIComponent(selectedCourseId))}`
                )
                : navigate(
                  `/viewchapter/${btoa(encodeURIComponent(selectedChapterId))}`
                );
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          triggerNotification("error", "Please try after sometime");
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error("Error creating assignment:", error);
      triggerNotification(
        "error",
        "An error occurred while creating the assignment."
      );
    }
  };

  return (
    <>
      <Breadcrumb txt="Manage Assignment" subpath={["Add Assignment"]} />

      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">Add Assignment</h5>
          </div>
          <div className="card-body">
            <form>
              {loading ? (
                <Spinner />
              ) : (
                <>
                  {/* title */}
                  <div className="form-floating form-floating-outline mb-3">
                    <input
                      type="text"
                      className="form-control"
                      name="cls"
                      id="cls"
                      placeholder="Title"
                      value={assgTitle}
                      onChange={handleAssgTitleChange}
                    />
                    <label htmlFor="cls">Title</label>
                  </div>

                  {/* Assignment For: CouseId/ ChapterId */}
                  <div className="col-md-12">
                    <div className="mb-2">
                      <label className="form-check-label select-none ml-1 mb-2">
                        Assignment For
                      </label>
                      <div>
                        <div className="form-check form-check-inline">
                          <input
                            name="form-check-group-image"
                            className="form-check-input"
                            type="radio"
                            value="course"
                            checked={assignmentFor === "course"}
                            id="course"
                            onChange={handleAssignmentForRadioChange}
                          />
                          <label className="form-check-label select-none" htmlFor="course">
                            Course
                          </label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            name="form-check-group-image"
                            className="form-check-input"
                            type="radio"
                            value="chapter"
                            checked={assignmentFor === "chapter"}
                            id="chapter"
                            onChange={handleAssignmentForRadioChange}
                          />
                          <label className="form-check-label select-none" htmlFor="chapter">
                            Chapter
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* Course dropdown with search functionality */}
                    <div className="form-floating form-floating-outline mb-4">
                      <div
                        className="form-control"
                        onClick={() => {
                          setIsCourseDropdownOpen(!isCourseDropdownOpen);
                          setIsChapterDropdownOpen(false)
                        }}
                        style={{
                          cursor: 'pointer',
                          textAlign: selectedCourseId ? "start" : "center"
                        }}
                      >
                        {selectedCourseId
                          ? courses.find((course) => course.course_id === selectedCourseId)?.course_name
                          : '--- Select Course ---'}
                      </div>

                      {isCourseDropdownOpen && (
                        <div
                          className="dropdown-menu show"
                          style={{
                            maxHeight: '200px',
                            overflowY: 'auto',
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            right: 0,
                            zIndex: 1,
                            width: '100%',
                            backgroundColor: 'white',
                            boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
                          }}
                        >
                          {/* Search input inside the course dropdown */}
                          <input
                            type="text"
                            className="form-control mb-2"
                            placeholder="Search Course..."
                            value={courseSearchTerm}
                            onChange={(e) => setCourseSearchTerm(e.target.value)}
                            style={{
                              padding: '5px',
                              margin: '8px 20px 8px 5px',
                              width: '95%',
                            }}
                          />
                          <ul className="list-unstyled p-0 m-0">
                            {filteredCourses.length > 0 ? (
                              filteredCourses.map((course) => (
                                <li
                                  key={course.course_id}
                                  className="dropdown-item"
                                  onClick={() => {
                                    handleSelectedCourseIdChange(course.course_id);
                                    setIsCourseDropdownOpen(false); // Close dropdown after selection

                                  }}
                                  style={{ cursor: 'pointer', padding: '5px' }}
                                >
                                  {course.course_name}
                                </li>
                              ))
                            ) : (
                              <li className="dropdown-item text-muted">No courses found</li>
                            )}
                          </ul>
                        </div>
                      )}

                      <label htmlFor="coursedropdown">Courses</label>
                    </div>

                    {/* Chapter dropdown with search functionality (Only if assignmentFor === 'chapter') */}
                    {assignmentFor === 'chapter' && (
                      <div className="form-floating form-floating-outline mb-4">
                        <div
                          className="form-control"
                          onClick={() => setIsChapterDropdownOpen(!isChapterDropdownOpen)}
                          style={{
                            cursor: 'pointer',
                            textAlign: selectedChapterId ? "start" : "center"
                          }}
                        >
                          {selectedChapterId
                            ? chapters.find((chapter) => chapter.chapterid === selectedChapterId)?.name
                            : '--- Select Chapter ---'}
                        </div>

                        {isChapterDropdownOpen && !isCourseDropdownOpen && (
                          <div
                            className="dropdown-menu show"
                            style={{
                              maxHeight: '200px',
                              overflowY: 'auto',
                              position: 'absolute',
                              top: '100%',
                              left: 0,
                              right: 0,
                              zIndex: 1,
                              width: '100%',
                              backgroundColor: 'white',
                              boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
                            }}
                          >
                            {/* Search input inside the chapter dropdown */}
                            <input
                              type="text"
                              className="form-control mb-2"
                              placeholder="Search Chapter..."
                              value={chapterSearchTerm}
                              onChange={(e) => setChapterSearchTerm(e.target.value)}
                              style={{
                                padding: '5px',
                                margin: '8px 20px 8px 5px',
                                width: '95%',
                              }}
                            />
                            <ul className="list-unstyled p-0 m-0">
                              {filteredChapters.length > 0 ? (
                                filteredChapters.map((chapter) => (
                                  <li
                                    key={chapter.chapterid}
                                    className="dropdown-item"
                                    onClick={() => {
                                      setSelectedChapterId(chapter.chapterid);
                                      setIsChapterDropdownOpen(false); // Close dropdown after selection
                                    }}
                                    style={{ cursor: 'pointer', padding: '5px' }}
                                  >
                                    {chapter.name}
                                  </li>
                                ))
                              ) : (
                                <li className="dropdown-item text-muted">No chapters found</li>
                              )}
                            </ul>
                          </div>
                        )}

                        <label htmlFor="chapterdropdown">Chapters</label>
                      </div>
                    )}
                  </div>
                  {/* time_limit_unit | time_limit */}
                  <div className="row">
                    <div className="col-md-7">
                      {/* time_limit, */}
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="number"
                          className="form-control"
                          name="cls"
                          id="cls"
                          placeholder="Time Limit"
                          value={assgTimeLimit}
                          onChange={handleAssgTimeLimitChange}
                        />
                        <label htmlFor="cls">Time Limit</label>
                      </div>
                    </div>

                    <div className="col-md-5">
                      {/* time_limit_unit, (weeks,days,hours) */}
                      <div className="form-floating form-floating-outline mb-4">
                        <select
                          className="form-select mx-auto"
                          id="assgTimeUnit"
                          aria-label="Time Unit"
                          value={assgTimeUnit}
                          onChange={handleAssgTimeUnitChange}
                        >
                          <option value="hours" className="text-center">
                            Hours
                          </option>
                          <option value="days" className="text-center">
                            Days
                          </option>
                          <option value="weeks" className="text-center">
                            Weeks
                          </option>
                        </select>

                        <label htmlFor="assgTimeUnit">Time Unit</label>
                      </div>
                    </div>
                  </div>

                  {/* points | passing_points */}
                  <div className="row">
                    <div className="col-md-6">
                      {/* points, */}
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="number"
                          className="form-control"
                          name="cls"
                          id="cls"
                          placeholder="Points"
                          value={assgPoints}
                          onChange={handleAssgPointsChange}
                        />
                        <label htmlFor="cls">Points</label>
                        <span className="text-gray-300 mdi mdi-alert-circle-outline">
                          {" "}
                          Maximum points a student can score
                        </span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      {/* passing_points, */}
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="number"
                          className="form-control"
                          name="cls"
                          id="cls"
                          placeholder="Passing Points"
                          value={assgPassingPoints}
                          onChange={handleAssgPassingPointsChange}
                        />
                        <label htmlFor="cls">Passing Points</label>
                        <div className="flex">
                          <span className="mdi mdi-alert-circle-outline text-gray-300 mr-1"></span>
                          <span className="text-gray-300 ">
                            {" "}
                            Maximum points required for the student to pass this
                            assignment
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* no_of_file_allowed | Max_file_size */}
                  <div className="row">
                    <div className="col-md-6">
                      {/* no_of_file_allowed, */}
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="number"
                          className="form-control"
                          name="cls"
                          id="cls"
                          placeholder="Number of file allowed"
                          value={assgNoFileAllw}
                          onChange={handleAssgNoFileAllwChange}
                        />
                        <label htmlFor="cls">Number of file allowed</label>
                        <div className="flex">
                          <span className="mdi mdi-alert-circle-outline text-gray-300 mr-1"></span>
                          <span className="text-gray-300 ">
                            {" "}
                            Define the number of files that a student can upload
                            in this assignment. Input 0 to disable the option to
                            upload
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      {/* Max_file_size, */}
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="number"
                          className="form-control"
                          name="cls"
                          id="cls"
                          placeholder="Maximum file size"
                          value={assgMaxFileSize}
                          onChange={handleAssgMaxFileSizeChange}
                        />
                        <label htmlFor="cls">Maximum file size limit</label>
                        <span className="text-gray-300 mdi mdi-alert-circle-outline">
                          {" "}
                          Define maximum file size attachment in MB
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* assignments, (array) */}
                  {!id && (
                    <MediaPopup
                      ttl="Assignment_Files"
                      linkValue={assgLinkValue}
                      setLinkValue={setAssgLinkValue}
                      mediaType="allfiles"
                      multiple
                    />
                  )}
                </>
              )}
              <div className={loading ? "d-none" : "d-block"}>
                {/* summary, (text editor) */}
                <label
                  htmlFor="assgSummary"
                  className="form-check-label ml-1 mb-2"
                >
                  Assignment Summary
                </label>
                <div className="form-floating form-floating-outline mb-4">
                  <CKEditor
                    name="assgSummary"
                    editor={ClassicEditor}
                    data={assgSummary}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      handleAssgSummaryChange(data);
                    }}
                  />
                </div>

                {/* submit */}
                <div className="mt-3 justify-content-end">
                  <div className="col-sm-10">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={addAssignment}
                    >
                      {id ? "update" : "Submit"}
                    </button>

                    {/* clear | calcel */}
                    <button
                      type="button"
                      className="btn ml-2 btn-secondary"
                      onClick={clearForm}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddAssignmentQue;
